import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConstructionPaintbrush = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M23.021 26.879L30.092 19.808L27.971 17.686H25.142V14.858L20.192 9.90796L13.121 16.979",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.414 17.686C11.212 18.888 11.212 20.727 12.414 21.929L13.828 23.343L9.65602 27.515C8.94902 28.222 8.80702 29.353 9.37302 30.202C10.151 31.263 11.565 31.263 12.414 30.414L16.657 26.171L18.071 27.585C19.273 28.787 21.112 28.787 22.314 27.585L23.021 26.878L13.121 16.979L12.414 17.686Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgConstructionPaintbrush);
export default ForwardRef;
